import { useCallback, useEffect, useState } from "react";
import {
  ChatInterface,
  createAssistantMessage,
  createUserMessage,
  type ChatMessage,
} from "../index";
import { sendMessage } from "../services/ChatService";
import "../styles.css";

export interface ChatContainerProps {
  title?: string;
  className?: string;
  standalone?: boolean;
}

const MAX_MESSAGES = 10;

const getMessages = () => {
  const messages = JSON.parse(localStorage.getItem('messages') || '[]');
  return messages.sort((a: ChatMessage, b: ChatMessage) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()).slice(messages.length - MAX_MESSAGES, messages.length);
}

export function ChatContainer({
  title = "CactAI Chat",
  className = "cactai-chat",
  standalone = false
}: ChatContainerProps) {
  const [messages, setMessages] = useState<ChatMessage[]>(getMessages());
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const newMessages = Array.from(
      new Map([...messages, ...JSON.parse(localStorage.getItem('messages') || '[]')].map(item => [item.id, item])).values()
    );
    localStorage.setItem('messages', JSON.stringify(newMessages));
  }, [messages]);

  const onSendMessage =
    async (content: string) => {
      setMessages((prev) => [...prev, createUserMessage(content)]);
      setIsLoading(true);

      const { response: reply, messageID } = await sendMessage(content);
      setMessages((prev) => [
        ...prev,
        createAssistantMessage(reply, messageID ? { id: messageID, messageID } : undefined),
      ]);
      setIsLoading(false);
    };

  return (
    <div className={`cactai-chat-container ${className}`.trim()}>
      <ChatInterface
        messages={messages}
        onSendMessage={onSendMessage}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        labels={{
          inputPlaceholder: "Send a message to CactAI...",
          emptyState: "Start the conversation",
        }}
        header={<div className="demo-chat__header">{title}</div>}
        isStandalone={standalone}
      />
    </div>
  );
}
